import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cloneDeep } from 'lodash';
import TableComponent from 'components/table-component-new/Table';
import TablePagination from 'components/table-component-new/TablePagination';
import { archivedSchedulesHeaderList } from '../utils';
import { CallAPI } from 'actions/General';
import ArchivedScheduleListHeader from './ArchivedScheduleListHeader';

const ArchivedScheduleList = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayEntries, setDisplayEntries] = useState(10);
  const [scheduleList, setScheduleList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filter, setFilter] = useState({});

  const handleDebouncedFilter = (name, value) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
  };

  const actionsCallBack = async (action, data) => {
    if (action === 'restore') {
      const payload = { scheduleIds: data.ids, state: 'active' };
      const result = await CallAPI('UPDATE_SCHEDULES_STATE', payload);
      if (result.status) {
        fetchScheduleList();
      }
    } else if (action === 'delete') {
      const payload = { scheduleIds: data.ids };
      const result = await CallAPI('DELETE_SCHEDULES', payload);
      if (result.status) {
        fetchScheduleList();
      }
    }
  };

  const fetchScheduleList = async (page = 1, limit = displayEntries) => {
    setSelectedRows([]);
    const payload = { state: 'archived', page, limit };
    if (filter.search) payload.searchText = filter.search;

    const result = await CallAPI('GET_ALL_SCHEDULES', payload, null, setLoading);
    if (result.status) {
      result.data.list.forEach((s) => {
        s.displayRefNumber = `ST-${s.referenceNumber}`;
        s.formTitle = s.form.title;
        s.companyFieldName = s.companyField?.fieldTitle ?? '';
      });
      setScheduleList(result.data.list);
      setTotalRecords(result.data.count);
    }
  };

  const onRowsSelection = (name, value) => {
    let tempSelection = [];

    if (name === 'all') {
      if (value) {
        tempSelection = scheduleList.map((s) => ({
          id: s._id,
        }));
      } else {
        tempSelection = [];
      }
    } else {
      tempSelection = cloneDeep(selectedRows);

      if (value) {
        tempSelection.push({ id: name });
      } else {
        tempSelection = tempSelection.filter((s) => s.id !== name);
      }
    }

    setSelectedRows(tempSelection);
  };

  useEffect(() => {
    fetchScheduleList();
  }, [filter]);

  return (
    <div>
      <div className='d-flex flex-column'>
        <label className='theme-size-2 theme-text-black-1'>
          {t('text_archived_schedule_task')}
        </label>
        {/* <label>
          Tasks planned for a future date or time. These will activate automatically when scheduled.
        </label> */}
      </div>
      <ArchivedScheduleListHeader
        handleDebouncedFilter={handleDebouncedFilter}
        selectedRows={selectedRows}
        actionsCallBack={actionsCallBack}
      />
      <TableComponent
        header={archivedSchedulesHeaderList}
        data={scheduleList}
        props={{
          actionsType: 'schedule',
          translateValueFunc: (val) => t(val),
        }}
        loader={loading}
        isFieldSelectionEnabled={false}
        isActionsEnabled={false}
        isSelectionEnabled={true}
        selectionKey={'_id'}
        onSelection={onRowsSelection}
        selectedRows={selectedRows}
        headerCellBorder='vertical'
        bodyCellBorder='both'
      />

      {totalRecords > 0 && (
        <TablePagination
          totalRecords={totalRecords}
          currentPageRecords={scheduleList.length}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          displayEntries={displayEntries}
          setDisplayEntries={setDisplayEntries}
          listingFunction={fetchScheduleList}
        />
      )}
    </div>
  );
};

export default ArchivedScheduleList;
